import { render, staticRenderFns } from "./ColorField.vue?vue&type=template&id=a84b9682&"
import script from "./ColorField.vue?vue&type=script&lang=js&"
export * from "./ColorField.vue?vue&type=script&lang=js&"
import style0 from "./ColorField.vue?vue&type=style&index=0&id=a84b9682&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports